import { useLocation, useNavigate } from 'react-router-dom';

import { Typography } from '@mui/material';

import { useBalanceStore } from '@/entities/balance';

import CroppedPercentImg from '@/shared/assets/images/cropped-percent.png';
import { PATHS } from '@/shared/constants/routes/paths';
import { useInterfaceLanguage } from '@/shared/i18n';
import { formatInterfaceCurrency } from '@/shared/i18n/formatLocale';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { SBackgroundImage, SButton, SContainer, SText, STextContainer } from './styled';

type UpgradeCardProps = {
  onClose: () => void;
};

export const UpgradeCard = ({ onClose }: UpgradeCardProps) => {
  const { locale, t } = useInterfaceLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const { hasArchivedSubscription } = useBalanceStore();

  const handleButtonClick = () => {
    if (hasArchivedSubscription) {
      MixpanelEvents.minutesModalViewPlansClick();
    }

    if (!hasArchivedSubscription) {
      MixpanelEvents.payLessMinutesButton();
    }

    navigate(`/${PATHS.pricing}`, {
      state: {
        path: `${location.pathname}${location.search}${location.hash}`,
        pricingEntryPoint: 'buy_minutes_upgrade',
      },
    });
    onClose();
  };

  return (
    <SContainer>
      <SBackgroundImage component="img" src={CroppedPercentImg} />

      <STextContainer>
        <Typography variant="body-2-md">
          {hasArchivedSubscription
            ? t('pricing.buyMinutes.newPricingTitle')
            : t('pricing.buyMinutes.payOnly', { price: formatInterfaceCurrency(locale, 150, 'usd') })}
        </Typography>

        <SText color="grey.500" variant="caption-1">
          {hasArchivedSubscription
            ? t('pricing.buyMinutes.newPricingDescription')
            : t('pricing.buyMinutes.upgradeDescription')}
        </SText>
      </STextContainer>

      <SButton data-testid="buy-minutes-modal-view-plans" variant="secondary" onClick={handleButtonClick}>
        {hasArchivedSubscription ? t('pricing.paywall.viewPlans') : t('pricing.buyMinutes.payLess')}
      </SButton>
    </SContainer>
  );
};
